/** Staff roles that may access /admin (enforced server-side per route). */
export const STAFF_ROLES = ["admin", "manager", "editor", "moderator"];

export function isStaffRole(role) {
  return role && STAFF_ROLES.includes(role);
}

export function canAccessBranding(role) {
  return role === "admin";
}

export function canAccessContentAdmin(role) {
  return role === "admin" || role === "editor";
}

export function canAccessSubscriptionAdmin(role) {
  return role === "admin" || role === "manager";
}

export function canEditUserRoles(role) {
  return role === "admin";
}

export function canWriteAppointments(role) {
  return role === "admin" || role === "manager";
}

export function canDeleteReports(role) {
  return role === "admin" || role === "manager";
}

export function canAccessBabyNamesAdmin(role) {
  return role === "admin" || role === "manager";
}

export function canAccessStoreAdmin(role) {
  return role === "admin" || role === "manager";
}
